<template>
  <div
    v-if="faq && faq.length"
    class="mx-0 m-auto my-[120px] rounded-[15px] overflow-hidden"
  >
    <h1
      class="text-primary-2-darker font-extrabold text-[30px] md:text-heading-2 text-center title-font mb-2.5"
    >
      {{ $t("faq.header") }}
    </h1>
    <div class="text-gray-1 text-center md:w-[650px] mx-auto">
      Explore our FAQ section to delve deeper into our offerings and find
      contents to commonly asked titles
    </div>
    <div class="my-[30px] md:w-[754px] mx-auto">
      <ListCard
        v-for="(item, i) in pageView ? faq : faq?.slice(0, 4)"
        :key="i"
        :question="item?.title"
        :answer="item?.content"
      />
    </div>
    <div class="text-center" v-if="!pageView && readAllButton">
      <BaseButton
        type="primary"
        class="!text-heading-6 !rounded-none max-md:!h-[54px] md:!h-[64px]"
        icon-class="rotate-90 bg-white text-primary-2 p-[10px] overflow-visible !mb-0  !text-[38px] rounded-full"
        append-icon="icon-arrow-up"
        label="Read All FAQs"
        @click="router.push(localePath('faq'))"
      />
    </div>
  </div>
</template>

<script setup>
import ListCard from "./FaqListCard.vue";
const router = useRouter();
const localePath = useLocalePath();
const config = useRuntimeConfig();

const props = defineProps({
  pageView: {
    type: Boolean,
    required: false,
  },
  readAllButton: { type: Boolean, default: true },
});
// const locale = useCookie("locale").value;
const { locale } = useI18n();
const faq = config.public.statics.faq ?? [];
const { data: meta } = await useAsyncData(`faq-meta-${locale.value}`, () =>
  customFetch("api/meta-data/page/faq"),
);
const metaTags = ref(meta.value);
useHead(() => ({
  script: props.pageView
    ? faq
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify(useFAQPageSchema(faq)),
          },
        ]
      : []
    : [],
}));

useHead(() => {
  if (!props.pageView || !metaTags.value) return {};

  return {
    title: metaTags.value.title,
    meta: [
      {
        name: "description",
        content: metaTags.value.description,
      },
      {
        property: "og:title",
        content: metaTags.value.title,
      },
      {
        property: "og:description",
        content: metaTags.value.description,
      },
    ],
  };
});
</script>
